import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-fd8f831a")

_pushScopeId("data-v-fd8f831a")
const _hoisted_1 = { class: "file-manager__viewer" }
const _hoisted_2 = { class: "viewer__container" }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = {
  key: 3,
  playsinline: "",
  controls: "",
  style: {"width":"100%"},
  ref: "video$"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Dialog = _resolveComponent("Dialog")
  const _component_Sidebar = _resolveComponent("Sidebar")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Dialog, {
      header: _ctx.titleDicomViewer,
      modal: true,
      class: "dicom-viewer p-dialog-maximized",
      style: { width: '100vw', height: '100vh' },
      visible: _ctx.showDicomViewer,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => (_ctx.showDicomViewer = $event))
    }, {
      default: _withId(() => [
        _createVNode("iframe", {
          src: _ctx.srcDicomViewer,
          width: "100%",
          height: "100%",
          allow: "display-capture"
        }, null, 8, ["src"])
      ]),
      _: 1
    }, 8, ["header", "visible"]),
    _createVNode("section", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        (!!_ctx.state.select && _ctx.state.select.DataType === _ctx.DataType.IMAGE)
          ? (_openBlock(), _createBlock("img", {
              key: 0,
              src: _ctx.getImagePath(_ctx.state.select.FilePath),
              style: 
          _ctx.state.isSlidebar
            ? 'width: 100%; cursor: zoom-in'
            : 'width: 100%; cursor: zoom-out'
        ,
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.state.visibleFull = true))
            }, null, 12, ["src"]))
          : _createCommentVNode("", true),
        (!!_ctx.state.select && _ctx.state.select.DataType === _ctx.DataType.DICOM)
          ? (_openBlock(), _createBlock("div", _hoisted_3, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.images, (image) => {
                return (_openBlock(), _createBlock("a", {
                  key: image.studyKey,
                  onClick: ($event: any) => (_ctx.openDicomViewer(_ctx.state.select, image.studyKey)),
                  target: "_blank"
                }, [
                  _createVNode("img", {
                    src: image.image,
                    style: {"cursor":"zoom-in","max-height":"100px"}
                  }, null, 8, ["src"])
                ], 8, ["onClick"]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        (!!_ctx.state.select && _ctx.state.select.FileType === _ctx.FileType.PDF)
          ? (_openBlock(), _createBlock("iframe", {
              key: 2,
              id: "pdfIframe",
              src: _ctx.getPdfPath(_ctx.state.select.FilePath),
              width: "100%",
              height: "100%",
              onLoad: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.pdfIframeLoad && _ctx.pdfIframeLoad(...args)))
            }, null, 40, ["src"]))
          : _createCommentVNode("", true),
        (!!_ctx.state.select && _ctx.state.select.DataType === _ctx.DataType.VIDEO)
          ? (_openBlock(), _createBlock("video", _hoisted_4, [
              _createVNode("source", {
                src: _ctx.getImagePath(_ctx.state.select.FilePath)
              }, null, 8, ["src"])
            ], 512))
          : _createCommentVNode("", true)
      ]),
      (_ctx.state.isSlidebar)
        ? (_openBlock(), _createBlock(_component_Sidebar, {
            key: 0,
            visible: _ctx.state.visibleFull,
            "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => (_ctx.state.visibleFull = $event)),
            baseZIndex: 1000,
            position: "full",
            style: {"padding":"20px"}
          }, {
            default: _withId(() => [
              _createVNode("div", null, [
                (!!_ctx.state.select && _ctx.state.select.DataType === _ctx.DataType.IMAGE)
                  ? (_openBlock(), _createBlock("img", {
                      key: 0,
                      class: "visible--full",
                      src: _ctx.getImagePath(_ctx.state.select.FilePath),
                      style: {"width":"100%","cursor":"zoom-out"},
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.state.visibleFull = false))
                    }, null, 8, ["src"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }, 8, ["visible"]))
        : _createCommentVNode("", true)
    ])
  ], 64))
})